import { useTradeStore } from "@/store/trade-store";
import { useTranslation } from "react-i18next";
// import { useGet24HVol } from "./hooks/useGet24hVol";
import { Pair } from "@/store/pairs";
import { useMemo } from "react";
import { formatDisplay } from "@/utils/format-display";
import { usePrice } from "@/store/price";
import { useShallow } from "zustand/shallow";
import clsx from "clsx";
import { formatNumberBalance } from "@/utils/numberFormat";
import CountdownUTC from "./countdown";
import { InfoIcon } from "@/icons";
import BigNumber from "bignumber.js";

export function TrandingData(props: { pair?: Pair; pairIndex: string }) {
    const { pair, pairIndex } = props;
    const { t } = useTranslation();

    const bookingInfo = useTradeStore((state) => state.booking);

    // const { formattedData } = useGet24HVol();

    const bookingInfoPair = bookingInfo.find(
        (item) => item.pair_index === Number(pairIndex)
    );

    // const pair24HVol = formattedData?.find(
    //     (item) => item.pairIndex === Number(pairIndex)
    // );

    const fundingRate = useMemo(() => {
        return `${formatDisplay(
            Math.abs(Number(bookingInfoPair?.funding_rate_long || 0) * 100),
            {
                decimalToShow: 5,
                minimumDecimalToShow: 5,
                disableSmallValue: true,
            }
        )}%`;
    }, [bookingInfoPair?.funding_rate_long]);

    const data = usePrice(useShallow((state) => state.data));

    return (
        <main className="w-full bg-white px-5 py-6 absolute inset-0">
            <div className="flex flex-col gap-5">
                <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-slate-500">
                        {t('24H Change')}
                    </span>

                    <span
                        className={clsx(
                            'text-sm font-bold px-1.5 py-0.5 rounded flex items-center gap-0.5 ',
                            {
                                'text-[#FF695F] bg-[#FF695F]/10':
                                    Number(data[pairIndex]?.price24h ?? 0) < 0,
                                'text-[#38F24A] bg-[#38F24A]/10':
                                    Number(data[pairIndex]?.price24h ?? 0) > 0,
                                'text-slate-900 bg-slate-900/10':
                                    Number(data[pairIndex]?.price24h ?? 0) == 0,
                            }
                        )}
                    >
                        {formatDisplay(Number(data[pairIndex]?.price24h ?? 0), {
                            decimalToShow: pair?.decimalsToShow ?? 5,
                            minimumDecimalToShow: 2,
                        })}
                        %
                    </span>
                </div>
                <hr className="border-slate-50" />
                <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-slate-500">
                        {t('Open Interest')}
                    </span>
                    <span className="text-sm font-bold text-slate-900 tabular-nums">
                        {formatNumberBalance(
                            new BigNumber(
                                Number(bookingInfoPair?.open_interest_long ?? 0)
                            )
                                .plus(
                                    new BigNumber(
                                        Number(
                                            bookingInfoPair?.open_interest_short ||
                                                0
                                        )
                                    )
                                )
                                .dividedBy(1e18)
                                .toNumber()
                        )}
                    </span>
                </div>
                {/* <hr className="border-slate-50" />
                <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-slate-500">
                        {t('24H Volume')}
                    </span>
                    <span className="text-sm font-bold text-slate-900 tabular-nums">
                        {formatNumberBalance(pair24HVol?.volume ?? 0)}
                    </span>
                </div> */}
                <hr className="border-slate-50" />
                <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-slate-500">
                        {t('Est. 1H Funding')}
                    </span>
                    <span className="text-sm font-bold text-slate-900 tabular-nums">
                        {fundingRate}
                    </span>
                </div>
                <hr className="border-slate-50" />
                <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-slate-500">
                        {t('Countdown')}
                    </span>
                    <CountdownUTC />
                </div>
                <hr className="border-slate-50" />
                <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-slate-500">
                        {t('Spread')}
                    </span>
                    <span className="text-sm font-bold text-slate-900 tabular-nums">
                        {bookingInfoPair?.spread}%
                    </span>
                </div>
            </div>
            <div className="mt-8 bg-surface-light rounded-2xl p-4 flex gap-3 items-start">
                
                <InfoIcon className='mt-0.5 text-slate-400 w-5 h-5' />
                <p className="text-xs text-slate-500 leading-relaxed flex-1">
                    {t('trading_data_info')}
                </p>
            </div>
        </main>
    );
}
